import { z } from "zod";

// Esquema para Dados do Cliente
const clienteSchema = z.object({
  nome_identificacao: z
    .string()
    .min(1, { message: "O nome de identificação é obrigatório!" })
    .min(3, {
      message: "O nome de identificação deve ter pelo menos 3 caracteres!",
    }),
  documento: z
    .string()
    .min(1, { message: "O CNPJ/CPF é obrigatório!" })
    .regex(/^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/, {
      message: "CNPJ/CPF inválido, formato esperado: 000.000.000-00 ou 00.000.000/0000-00!",
    }),
  email: z
    .string()
    .min(1, { message: "O e-mail é obrigatório!" })
    .email({ message: "E-mail inválido!" }),
  telefone_contato: z
    .string()
    .min(1, { message: "O telefone da pessoa para contato é obrigatório!" })
    .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, {
      message: "Telefone inválido, formato esperado: (XX) XXXXX-XXXX!",
    }),
});

// Exportando os esquemas para validação
export { clienteSchema };
